<span
  class="rb"
  role="img"
  data-testid="module-recursive-badge"
  [attr.aria-label]="'modules.recursive.aria' | translate: depth"
  [matTooltip]="'modules.recursive.tooltip' | translate: depth"
>
  <mat-icon class="rb__icon" aria-hidden="true">autorenew</mat-icon>
  <span class="rb__label">{{ 'modules.recursive.label' | translate }}</span>
</span>
